export const mx = {
  textDictionary: {
    COMBO_GTD_MANQUEHUE_LABEL: 'GTD Manquehue',
    FILTERS_TITLE_REBRANDING_MOBILE: 'Filtrar por:',
    ORDER_BY_DESKTOP: 'Ordenar por',
    OF: 'de',
    Results: 'Resultados',
    SEE_MORE: 'ver más',
    SEE_LESS: 'ver menos',
    SEE_MORE_FACET_VALUES: '+ Ver más',
    SEE_LESS_FACET_VALUES: '+ Ver menos',
    XLP_VIEW_PRODUCT_MOBILE: 'Ver más',
  },
  toggles: {
    NEW_PROMOTION_CALL: false,
    disableSponsoredProducts: true,
    isDynamicFacetsEnabled: true,
  },
};
